export const updateTicker = [
  '第 8 阶段更新：海角黑料后续进展补充说明已整理完毕',
  '时间线新增 2 个关键节点，起因部分补充背景线索',
  '海角黑料事件始末速览卡已更新，可从上往下顺序阅读',
  '答疑区新增「海角黑料后续是否还有新进展」的解读',
  '讨论区今日新增 37 条留言，互动热度持续',
  '事件经过的 4 个阶段已按时间顺序重新校对',
];

export const heroStats = [
  { label: '已梳理关键节点', value: '24', unit: '个' },
  { label: '覆盖发展阶段', value: '8', unit: '段' },
  { label: '时间跨度', value: '5', unit: '个月' },
  { label: '最近更新', value: '09-10', unit: '' },
];

export const keyNodes = [
  {
    tag: '起因',
    date: '05-02',
    title: '苗头初现',
    desc: '海角黑料最早的相关线索出现，讨论仍在小范围进行。',
  },
  {
    tag: '发酵',
    date: '05-18',
    title: '首次公开回应',
    desc: '相关方首次作出公开说明，事件进入大众视野。',
  },
  {
    tag: '高潮',
    date: '06-27',
    title: '多方集中表态',
    desc: '多个信源在同一时间发声，讨论量达到阶段峰值。',
  },
  {
    tag: '后续',
    date: '09-04',
    title: '后续进展更新',
    desc: '阶段性结论浮现，海角黑料后续走向逐渐清晰。',
  },
];

export const causePoints = [
  {
    title: '背景线索长期累积',
    desc: '海角黑料起因并非单点爆发，而是多条零散线索在数月间不断叠加，最终形成可被集中讨论的素材。',
  },
  {
    title: '关键信息首次公开',
    desc: '一份被反复引用的信息把原本分散的片段串成一条线，成为事件从私域讨论走向公开的重要起点。',
  },
  {
    title: '传播节点被放大',
    desc: '当讨论被搬到更开放的场域，事件经过被不断转述与再解读，海角黑料事件的影响力随之扩大。',
  },
];

export const timeline = [
  {
    date: '2026-05-02',
    phase: '起因',
    title: '海角黑料最早的线索出现',
    desc: '关于海角黑料起因的第一批零散信息出现在小范围讨论中，内容零碎、指向模糊，尚未形成完整叙事。此时大多数人只是围观，并未意识到后续会持续发酵。',
    image:
      'https://readdy.ai/api/search-image?query=moody%20editorial%20photograph%20of%20faint%20morning%20light%20through%20a%20window%20onto%20an%20empty%20cream%20desk%20with%20scattered%20paper%20notes%2C%20warm%20cream%20and%20deep%20vermilion%20palette%2C%20soft%20diffused%20lighting%2C%20minimal%20clean%20composition%2C%20subtle%20film%20grain%2C%20no%20people%2C%20cinematic%20and%20atmospheric%2C%20high%20detail%2C%20consistent%20warm%20tone&width=800&height=600&seq=hej-tl-01&orientation=landscape',
  },
  {
    date: '2026-05-09',
    phase: '起因',
    title: '相关线索被集中整理',
    desc: '有人开始把此前零散的内容按时间顺序整理成表格与截图合集。海角黑料始末的第一版「时间线」由此出现，也让更多人第一次看清脉络走向。',
    image:
      'https://readdy.ai/api/search-image?query=moody%20editorial%20photograph%20of%20a%20cream%20pin%20board%20with%20clustered%20paper%20clippings%20connected%20by%20thin%20red%20strings%2C%20warm%20cream%20and%20deep%20vermilion%20palette%2C%20soft%20diffused%20lighting%2C%20minimal%20clean%20composition%2C%20subtle%20film%20grain%2C%20no%20people%2C%20cinematic%20and%20atmospheric%2C%20high%20detail%2C%20consistent%20warm%20tone&width=800&height=600&seq=hej-tl-02&orientation=landscape',
  },
  {
    date: '2026-05-18',
    phase: '发酵',
    title: '相关方首次公开回应',
    desc: '第一次正式回应出现，事件从私下议论转向公开讨论。回应中的表述被反复引用，也成为理解海角黑料经过的重要参照点。',
    image:
      'https://readdy.ai/api/search-image?query=moody%20editorial%20photograph%20of%20a%20single%20red%20sealed%20envelope%20resting%20on%20a%20smooth%20cream%20surface%2C%20warm%20cream%20and%20deep%20vermilion%20palette%2C%20soft%20diffused%20lighting%2C%20minimal%20clean%20composition%2C%20subtle%20film%20grain%2C%20no%20people%2C%20cinematic%20and%20atmospheric%2C%20high%20detail%2C%20consistent%20warm%20tone&width=800&height=600&seq=hej-tl-03&orientation=landscape',
  },
  {
    date: '2026-06-03',
    phase: '发酵',
    title: '讨论热度持续上升',
    desc: '围绕回应内容的分歧越来越多，讨论重心从「发生了什么」转向「为什么这样」。海角黑料事件由此进入持续升温的阶段。',
    image:
      'https://readdy.ai/api/search-image?query=moody%20editorial%20photograph%20of%20a%20warm%20desk%20lamp%20glowing%20over%20stacked%20papers%20at%20dusk%2C%20warm%20cream%20and%20deep%20vermilion%20palette%2C%20soft%20diffused%20lighting%2C%20minimal%20clean%20composition%2C%20subtle%20film%20grain%2C%20no%20people%2C%20cinematic%20and%20atmospheric%2C%20high%20detail%2C%20consistent%20warm%20tone&width=800&height=600&seq=hej-tl-04&orientation=landscape',
  },
  {
    date: '2026-06-27',
    phase: '高潮',
    title: '多方在同一时间集中表态',
    desc: '多个信源在相近时间发声，事件关注度达到阶段峰值。这一节点被普遍视为理解海角黑料始末的关键枢纽，也让时间线更加完整。',
    image:
      'https://readdy.ai/api/search-image?query=moody%20editorial%20photograph%20of%20dramatic%20long%20shadows%20across%20a%20bare%20cream%20wall%20with%20one%20minimal%20frame%2C%20warm%20cream%20and%20deep%20vermilion%20palette%2C%20soft%20diffused%20lighting%2C%20minimal%20clean%20composition%2C%20subtle%20film%20grain%2C%20no%20people%2C%20cinematic%20and%20atmospheric%2C%20high%20detail%2C%20consistent%20warm%20tone&width=800&height=600&seq=hej-tl-05&orientation=landscape',
  },
  {
    date: '2026-07-15',
    phase: '高潮',
    title: '争议焦点向外转移',
    desc: '讨论从单一事件延伸到更广的话题，观点出现明显分层。海角黑料经过到了这个阶段，已经从「信息」变成了持续被解读的「议题」。',
    image:
      'https://readdy.ai/api/search-image?query=moody%20editorial%20photograph%20of%20a%20neat%20stack%20of%20folded%20newspapers%20bound%20with%20deep%20red%20thread%20on%20cream%20surface%2C%20warm%20cream%20and%20deep%20vermilion%20palette%2C%20soft%20diffused%20lighting%2C%20minimal%20clean%20composition%2C%20subtle%20film%20grain%2C%20no%20people%2C%20cinematic%20and%20atmospheric%2C%20high%20detail%2C%20consistent%20warm%20tone&width=800&height=600&seq=hej-tl-06&orientation=landscape',
  },
  {
    date: '2026-08-20',
    phase: '后续',
    title: '阶段性结论逐渐浮现',
    desc: '随着讨论退潮，一些更稳定的判断开始成形。海角黑料后续不再是每天都有新说法，而是进入沉淀与复盘的阶段。',
    image:
      'https://readdy.ai/api/search-image?query=moody%20editorial%20photograph%20of%20calm%20dawn%20light%20filling%20a%20minimal%20cream%20interior%20with%20a%20wooden%20stool%2C%20warm%20cream%20and%20deep%20vermilion%20palette%2C%20soft%20diffused%20lighting%2C%20minimal%20clean%20composition%2C%20subtle%20film%20grain%2C%20no%20people%2C%20cinematic%20and%20atmospheric%2C%20high%20detail%2C%20consistent%20warm%20tone&width=800&height=600&seq=hej-tl-07&orientation=landscape',
  },
  {
    date: '2026-09-04',
    phase: '后续',
    title: '最新进展与补充说明',
    desc: '最新一轮更新对前期内容做了校对与补充。至此海角黑料始末的完整脉络基本成型，可按本页时间线从头到尾顺畅看完。',
    image:
      'https://readdy.ai/api/search-image?query=moody%20editorial%20photograph%20of%20cleanly%20organized%20papers%20and%20a%20slim%20pen%20under%20soft%20studio%20light%20on%20cream%20desk%2C%20warm%20cream%20and%20deep%20vermilion%20palette%2C%20soft%20diffused%20lighting%2C%20minimal%20clean%20composition%2C%20subtle%20film%20grain%2C%20no%20people%2C%20cinematic%20and%20atmospheric%2C%20high%20detail%2C%20consistent%20warm%20tone&width=800&height=600&seq=hej-tl-08&orientation=landscape',
  },
];

export const followUps = [
  {
    tag: '进展',
    date: '2026-09-04',
    title: '后续说明完成补充',
    desc: '最新一轮更新补齐了此前缺失的细节，让海角黑料后续的时间线更加连贯。',
    image:
      'https://readdy.ai/api/search-image?query=moody%20editorial%20photograph%20of%20fresh%20sheets%20of%20paper%20and%20a%20pen%20on%20a%20cream%20desk%2C%20warm%20cream%20and%20deep%20vermilion%20palette%2C%20soft%20diffused%20lighting%2C%20minimal%20clean%20composition%2C%20subtle%20film%20grain%2C%20no%20people%2C%20cinematic%20and%20atmospheric%2C%20high%20detail%2C%20consistent%20warm%20tone&width=800&height=600&seq=hej-fu-01&orientation=landscape',
  },
  {
    tag: '复盘',
    date: '2026-08-20',
    title: '阶段结论逐步稳定',
    desc: '讨论退潮后留下的判断更加稳定，也让事件始末的复盘有了更扎实的基础。',
    image:
      'https://readdy.ai/api/search-image?query=moody%20editorial%20photograph%20of%20a%20minimal%20paper%20calendar%20and%20notes%20in%20warm%20afternoon%20light%20on%20cream%20surface%2C%20warm%20cream%20and%20deep%20vermilion%20palette%2C%20soft%20diffused%20lighting%2C%20minimal%20clean%20composition%2C%20subtle%20film%20grain%2C%20no%20people%2C%20cinematic%20and%20atmospheric%2C%20high%20detail%2C%20consistent%20warm%20tone&width=800&height=600&seq=hej-fu-02&orientation=landscape',
  },
  {
    tag: '观察',
    date: '2026-07-15',
    title: '话题外延仍在持续',
    desc: '争议焦点向外延伸，后海角黑料时期的讨论方式与最初已明显不同。',
    image:
      'https://readdy.ai/api/search-image?query=moody%20editorial%20photograph%20of%20a%20quiet%20evening%20desk%20with%20a%20single%20lamp%20and%20a%20closed%20notebook%2C%20warm%20cream%20and%20deep%20vermilion%20palette%2C%20soft%20diffused%20lighting%2C%20minimal%20clean%20composition%2C%20subtle%20film%20grain%2C%20no%20people%2C%20cinematic%20and%20atmospheric%2C%20high%20detail%2C%20consistent%20warm%20tone&width=800&height=600&seq=hej-fu-03&orientation=landscape',
  },
];

export const faqs = [
  {
    q: '海角黑料起因到底是什么？',
    a: '海角黑料起因是多条零散线索在数月内不断累积的结果，并非单一事件引爆。本页「事件起因」一栏把背景、关键信息与传播节点分三点讲清。',
  },
  {
    q: '看这个时间线需要按顺序读吗？',
    a: '建议从上往下顺序阅读。时间线按时间顺序排列，每个节点都标注了阶段与日期，顺序读完即可掌握海角黑料经过的完整脉络。',
  },
  {
    q: '海角黑料后续还会有新进展吗？',
    a: '后续进展会随公开信息变化而更新。本页顶部更新条会标注最近更新时间，阅读时可以先看一眼更新条再进入正文。',
  },
  {
    q: '页面内容和原始信息有出入怎么办？',
    a: '本页内容是对公开信息的整理与归纳，可能存在转述差异。涉及判断的部分仅作脉络参考，请以权威来源的原始表述为准。',
  },
  {
    q: '为什么只做时间线，不做长篇评论？',
    a: '因为多数读者的核心诉求是「快速看懂始末」。与其堆砌观点，不如把起因、经过、后续按时间排好，让关键节点一眼可见。',
  },
];

export const comments = [
  {
    name: '旧港听风',
    initial: '港',
    time: '2 小时前',
    text: '时间线排得挺清楚的，起因那一段终于看明白了，之前一直云里雾里。',
    likes: 128,
    accent: 'primary',
  },
  {
    name: '半页笔记',
    initial: '笔',
    time: '5 小时前',
    text: '06-27 那个节点确实关键，多方集中表态之后整个海角黑料事件的性质就不一样了。',
    likes: 96,
    accent: 'accent',
  },
  {
    name: '灯塔观察',
    initial: '灯',
    time: '昨天',
    text: '希望后续能再补一版更细的对比，现在这版已经比到处翻碎片信息好太多了。',
    likes: 74,
    accent: 'secondary',
  },
  {
    name: '空白便签',
    initial: '签',
    time: '前天',
    text: '先收藏，等海角黑料后续有新进展再回来对照着看。',
    likes: 41,
    accent: 'primary',
  },
];

export const entryResources = [
  {
    icon: 'ri-question-line',
    title: '事件起因',
    desc: '三点背景讲清海角黑料起因',
    href: '#cause',
  },
  {
    icon: 'ri-time-line',
    title: '完整时间线',
    desc: '24 个关键节点按序排列',
    href: '#timeline',
  },
  {
    icon: 'ri-refresh-line',
    title: '后续进展',
    desc: '当前阶段的最新跟进',
    href: '#followup',
  },
  {
    icon: 'ri-question-answer-line',
    title: '常见疑问',
    desc: '阅读前的高频问题解答',
    href: '#faq',
  },
  {
    icon: 'ri-chat-3-line',
    title: '讨论区',
    desc: '看看别人怎么理解这件事',
    href: '#discussion',
  },
  {
    icon: 'ri-bookmark-line',
    title: '关键速览',
    desc: '四个阶段一眼看懂脉络',
    href: '#overview',
  },
];